import {TeachBlock, TeachBlockPage} from "./types";
const base = process.env.PUBLIC_URL || ``;

export const branch0Alexey = {
    start: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: 'patientAnalyzesDefault',
        cardClick: 'patientAlexeyCardFirst',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },

    patientAlexeyCardFirst: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "AlexeyAnalyzes",
            closeClick: "tuktukAlexey",
            pages: [`${base}/images/patient_alexey_card1.png`, `${base}/images/patient_alexey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    patientAlexeyCard: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "AlexeyAnalyzesAfter",
            closeClick: "alexeyFirstQuestion",
            pages: [`${base}/images/patient_alexey_card1.png`, `${base}/images/patient_alexey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    tuktukAlexey: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: 'Слабый и медленный стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {
                text: "Входите 💡",
                type: "nextStep",
                gotoStep: 'enterAlexey',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    enterAlexey: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyEnter.jpg`,
        buttons: [
            {
                text: "Здравствуйте, проходите, рассказывайте.",
                type: "nextStep",
                gotoStep: 'alexeyFirstQuestion',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyFirstQuestion: {
        patient: 'Alexey',
        branch: 1,
        name: 'Алексей',
        text: 'Да я в целом в порядке, это, наверное, возрастное... Мне поставили диагноз железодефицитная анемия. Впрочем, чего я хотел? Вся жизнь на Севере, да на вышках нефтяных. Какого здоровья тут ждать богатырского?<br>А жена говорит, мол, нет, приехал новый гематолог - иди, проверься. Ну вот я и пришел.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Опросить",
                type: "nextStep",
                gotoStep: 'alexeyQuestions',
                value: false,
                redColor: false,
                answered: false,
                canDisabled: true
            },
            {
                text: "Посмотреть анализы",
                type: "nextStep",
                gotoStep: 'AlexeyAnalyzesAfter',
                value: false,
                redColor: false,
                answered: false,
                canDisabled: true
            },
            {
                text: "Далее",
                type: "nextStep",
                gotoStep: 'alexeyVisit1AfterQuestion',
                value: false,
                redColor: false,
                answered: true,
                canDisabled: false,
                startInvisible: true
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyQuestions: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Усталость и анемия",
                type: "nextStep",
                gotoStep: 'alexeyQuestion1',
                value: false,
                redColor: false,
                answered: false,
                canDisabled: true,
                page: 1
            },
            {
                text: "Тромбозы",
                type: "nextStep",
                gotoStep: 'alexeyQuestion2',
                value: false,
                redColor: false,
                answered: false,
                width: 'calc(50% - 8px)',
                canDisabled: true,
                page: 1
            },
            {
                text: "Отечность ног",
                type: "nextStep",
                gotoStep: 'alexeyQuestion3',
                value: false,
                redColor: false,
                answered: false,
                width: 'calc(50% - 8px)',
                canDisabled: true,
                page: 1
            },
            {
                text: "Физическая нагрузка",
                type: "nextStep",
                gotoStep: 'alexeyQuestion4',
                value: false,
                redColor: false,
                answered: false,
                canDisabled: true,
                page: 1
            },
            {
                text: "Боль в животе",
                type: "nextStep",
                gotoStep: 'alexeyQuestion5',
                value: false,
                redColor: false,
                answered: false,
                canDisabled: true,
                page: 2
            },
            {
                text: "Темный цвет мочи по утрам",
                type: "nextStep",
                gotoStep: 'alexeyQuestion6',
                value: false,
                redColor: false,
                answered: false,
                canDisabled: true,
                page: 2
            },
            {
                text: "Иные жалобы",
                type: "nextStep",
                gotoStep: 'alexeyQuestion7',
                value: false,
                redColor: false,
                answered: false,
                canDisabled: true,
                page: 2
            },
            {
                text: "arrow_prev",
                type: "nextStep",
                gotoStep: '',
                value: false,
                redColor: false,
                answered: true,
                width: 'calc(50% - 8px)',
                canDisabled: false
            },
            {
                text: "arrow_next",
                type: "nextStep",
                gotoStep: '',
                value: false,
                redColor: false,
                answered: true,
                width: 'calc(50% - 8px)',
                canDisabled: false
            },
            {
                text: "Далее",
                type: "nextStep",
                gotoStep: 'alexeyFirstQuestion',
                value: false,
                redColor: false,
                answered: true,
                canDisabled: true
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyQuestion1: {
        patient: 'Alexey',
        branch: 1,
        name: 'Алексей',
        text: 'Устаю очень сильно. С другой стороны, а кто не устает?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Опросить",
                type: "nextStep",
                gotoStep: 'alexeyQuestions',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyQuestion2: {
        patient: 'Alexey',
        branch: 1,
        name: 'Алексей',
        text: 'Нет, доктор, таких проблем не наблюдается.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Опросить",
                type: "nextStep",
                gotoStep: 'alexeyQuestions',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyQuestion3: {
        patient: 'Alexey',
        branch: 1,
        name: 'Алексей',
        text: 'Нет, доктор, таких проблем не наблюдается.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Опросить",
                type: "nextStep",
                gotoStep: 'alexeyQuestions',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyQuestion4: {
        patient: 'Alexey',
        branch: 1,
        name: 'Алексей',
        text: 'Появилась одышка некоторое время назад, очень тяжело стало на работу ходить. Не до спорта сейчас.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Опросить",
                type: "nextStep",
                gotoStep: 'alexeyQuestions',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyQuestion5: {
        patient: 'Alexey',
        branch: 1,
        name: 'Алексей',
        text: 'Боль периодически появляется, а затем сама проходит. Точно не могу сказать где.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Опросить",
                type: "nextStep",
                gotoStep: 'alexeyQuestions',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyQuestion6: {
        patient: 'Alexey',
        branch: 1,
        name: 'Алексей',
        text: 'Пару раз обратил внимание, что цвет мочи по утрам очень темный, но особого значения этому не придал.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Опросить",
                type: "nextStep",
                gotoStep: 'alexeyQuestions',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyQuestion7: {
        patient: 'Alexey',
        branch: 1,
        name: 'Алексей',
        text: 'Знаете, доктор. Есть еще одна жалоба... Но я не знаю, это я по адресу или нет. Вдруг не связано? Но у меня с потенцией как-то не очень в последнее время. Списывал на усталость сначала. Но усталость не проходит. И проблема тоже не решается.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Опросить",
                type: "nextStep",
                gotoStep: 'alexeyQuestions',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    patientAnalyzesDefault: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "start",
            nextClick: "start",
            windowType: 0,
            analyzes: [
                [""],
                [""],
                [""],
                [""],
                [""]
            ],
            analyzesHeights: [
                [394],
                [680],
                [],
                [],
                []
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    AlexeyAnalyzes: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/AlexeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "patientAlexeyCardFirst",
            nextClick: "tuktukAlexey",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_alexey_1_1_table.jpg`],
                [`${base}/images/analiz_alexey_1_2_table.jpg`],
                [],
                [],
                []
            ],
            analyzesHeights: [
                [394],
                [680],
                [],
                [],
                []
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    AlexeyAnalyzesAfter: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/AlexeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "patientAlexeyCard",
            nextClick: "alexeyFirstQuestion",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_alexey_1_1_table.jpg`],
                [`${base}/images/analiz_alexey_1_2_table.jpg`],
                [],
                [],
                []
            ],
            analyzesHeights: [
                [394],
                [680],
                [],
                [],
                []
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit1AfterQuestion: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Физикальный осмотр",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Osmotr',
                value: false,
                redColor: false,
                answered: false,
                canDisabled: true
            },
            {
                text: "Далее",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Mind',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit1Osmotr: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Пульс",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Osmotr1',
                value: false,
                redColor: false,
                answered: false,
                canDisabled: true
            },
            {
                text: "Кожа",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Osmotr2',
                value: false,
                redColor: false,
                answered: false,
                canDisabled: true
            },
            {
                text: "Пальпация живота",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Osmotr3',
                value: false,
                redColor: false,
                answered: false,
                canDisabled: true
            },
            {
                text: "Далее",
                type: "nextStep",
                gotoStep: 'alexeyVisit1AfterQuestion',
                value: false,
                redColor: false,
                answered: true,
                canDisabled: true
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit1Osmotr1: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: 'Тахикардия. ЧСС - 100 уд/м',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Назад",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Osmotr',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit1Osmotr2: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: 'Наблюдается заметная бледность кожных покровов, а также желтушность склер',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Назад",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Osmotr',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit1Osmotr3: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: 'При пальпации отклонений не обнаружено',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Назад",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Osmotr',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit1Mind: {
        patient: 'Alexey',
        branch: 1,
        name: '💭 Размышления',
        text: '<i>Пациент отмечает усталость и утомляемость, а в лабораторных исследованиях обнаружена высокая активность лактатдегидрогеназы, общего билирубина, а также низкий уровень гемоглобина. Что это может означать?</i>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Далее",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Attantion',
                value: false,
                redColor: false,
                answered: false
            }
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit1Attantion: {
        patient: 'Alexey',
        branch: 1,
        name: '❗ ВНИМАНИЕ',
        text: '📘 Доступен новый материал! Изучите его как можно скорее, чтобы получить награду и увеличить шанс на верный ответ! 🏅🎉<br><br>👀 Нажмите <strong>"Читать справочник"</strong> – там свежий материал!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Читать справочник",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Read1',
                value: false,
                redColor: true,
                answered: false
            },
            {
                text: "Предположить диагноз",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Diagnoz',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit1Read1: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/AlexeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {
            closeClick: "alexeyGematogen1",
            pages: [
                {image: `${base}/images/alexey_teach1_1.png`, scroll: true},
            ]
        }
    },
    alexeyGematogen1: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '<strong>А вот и награда!</strong> Держите гематогенку в шуршащем фантике!<br><br><strong>Количество 🍫: (отображение)</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: true,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: 'firstPrize',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/gematogenka.mp3`,
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Назад",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Attantion',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit1Diagnoz: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '160px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Гемолитический синдром неустановленной этиологии",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Diagnoz1',
                value: false,
                redColor: false,
                answered: false
            },
            {
                text: "Анемия неясного генеза",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Diagnoz2',
                value: false,
                redColor: false,
                answered: false,
                width: 'calc(70% - 8px)'
            },
            {
                text: "ЖДА",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Diagnoz3',
                value: false,
                redColor: false,
                answered: false,
                width: 'calc(30% - 8px)'
            },
            {
                text: "Вернуться к справочнику",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Read1',
                value: false,
                redColor: true,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit1Diagnoz1: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: 'У пациента наблюдается один из основных признаков внутрисосудистого гемолиза - повышение активности ЛДГ. Это может быть как, например, аутоимунная гемолитическая анемия, так и редкое заболевание ПНГ (пароксизмальная ночная гемоглобинурия).<br><br><strong>Верное направление!</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Ссылка",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Diagnoz1Link',
                value: false,
                redColor: false,
                answered: false
            },
            {
                text: "Далее",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Win',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit1Diagnoz2: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: 'У пациента наблюдается один из основных признаков внутрисосудистого гемолиза - повышение активности ЛДГ. Это может быть как, например, аутоимунная гемолитическая анемия, так и редкое заболевание ПНГ (пароксизмальная ночная гемоглобинурия). <br><br><strong>Так что, неверный диагноз.</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Ссылка",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Diagnoz2Link',
                value: false,
                redColor: false,
                answered: false
            },
            {
                text: "Назад",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Diagnoz',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit1Diagnoz3: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: 'У пациента наблюдается один из основных признаков внутрисосудистого гемолиза - повышение активности ЛДГ. Это может быть как, например, аутоимунная гемолитическая анемия, так и редкое заболевание ПНГ (пароксизмальная ночная гемоглобинурия). <br><br><strong>Так что, неверный диагноз.</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Ссылка",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Diagnoz3Link',
                value: false,
                redColor: false,
                answered: false
            },
            {
                text: "Назад",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Diagnoz',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit1Diagnoz1Link: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '<strong>Клинические рекомендации по диагностике и лечению аутоиммунной гемолитической анемии (АИГА) у взрослых // Национальное гематологическое общество</strong><br><a href="https://www.volgmed.ru/uploads/files/2018-4/83281-gemoliticheskaya_anemiya_2018.pdf">https://www.volgmed.ru/uploads/files/2018-4/83281-gemoliticheskaya_anemiya_2018.pdf</a><br>(дата обращения: 11.11.2025)<br><br><strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Назад",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Diagnoz1',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit1Diagnoz2Link: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '<strong>Клинические рекомендации по диагностике и лечению аутоиммунной гемолитической анемии (АИГА) у взрослых // Национальное гематологическое общество</strong><br><a href="https://www.volgmed.ru/uploads/files/2018-4/83281-gemoliticheskaya_anemiya_2018.pdf">https://www.volgmed.ru/uploads/files/2018-4/83281-gemoliticheskaya_anemiya_2018.pdf</a><br>(дата обращения: 11.11.2025)<br><br><strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Назад",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Diagnoz2',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit1Diagnoz3Link: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '<strong>Клинические рекомендации по диагностике и лечению аутоиммунной гемолитической анемии (АИГА) у взрослых // Национальное гематологическое общество</strong><br><a href="https://www.volgmed.ru/uploads/files/2018-4/83281-gemoliticheskaya_anemiya_2018.pdf">https://www.volgmed.ru/uploads/files/2018-4/83281-gemoliticheskaya_anemiya_2018.pdf</a><br>(дата обращения: 11.11.2025)<br><br><strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)<br><br><strong>Клинические рекомендации “Железодефицитная анемия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/view-cr/669_2">https://cr.minzdrav.gov.ru/view-cr/669_2</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Назад",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Diagnoz3',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit1Win: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '<strong>Совершенно верно! + 30 баллов!<br><br>🏆 Ваш рейтинг: ???⭐<br><br>Как повысить рейтинг?</strong><br>✅ За каждый верный ответ вы получаете баллы рейтинга! 🩺🧠<br>✅ Изучение новой информации в приложении увеличивает шансы на верные решения!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/points.mp3`,
        rating: 30,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Далее",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Mind2',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit1Mind2: {
        patient: 'Alexey',
        branch: 1,
        name: '💭 Размышления',
        text: '<i>Каким образом мы можем подтвердить или опровергнуть тот или иной диагноз? Ведь ПНГ - это крайне редкое заболевание.</i>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/mind.mp3`,
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Ссылка",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Mind2Link',
                value: false,
                redColor: false,
                answered: false
            },
            {
                text: "Далее",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Attantion2',
                value: false,
                redColor: false,
                answered: false
            }
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit1Mind2Link: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Назад",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Mind2',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit1Attantion2: {
        patient: 'Alexey',
        branch: 1,
        name: '❗ ВНИМАНИЕ',
        text: '📘 Доступен новый материал! Изучите его как можно скорее, чтобы получить награду и увеличить шанс на верный ответ! 🏅🎉<br><br>👀 Нажмите <strong>"Читать справочник"</strong> – там свежий материал!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Читать справочник",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Read2',
                value: false,
                redColor: true,
                answered: false
            },
            {
                text: "Назначить анализы",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Naznachenie',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit1Read2: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/AlexeyCabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {
            closeClick: "alexeyGematogen2",
            pages: [
                {image: `${base}/images/alexey_teach2_1.png`, scroll: true},
                {image: `${base}/images/alexey_teach2_2.png`, scroll: true},
                {image: `${base}/images/alexey_teach2_3.png`, scroll: true},
            ]
        }
    },
    alexeyGematogen2: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '<strong>А вот и награда!</strong> Держите гематогенку в шуршащем фантике!<br><br><strong>Количество 🍫: (отображение)</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: true,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: 'firstPrize',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/gematogenka.mp3`,
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Назад",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Attantion2',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit1Naznachenie: {
        patient: 'Alexey',
        branch: 1,
        name: 'Вы',
        text: 'Я думаю, что вам необходимо провести следующие исследования: проточная цитометрия и прямая проба Кумбса. Так мы сможем более точно понять Ваш диагноз по результатам этих исследований. Сейчас картина неполная. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Далее",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Naznachenie2',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit1Naznachenie2: {
        patient: 'Alexey',
        branch: 1,
        name: 'Алексей',
        text: 'Хорошо, доктор! Я понял, сделаю все анализы и скорее к Вам.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Записать пациента",
                type: "nextStep",
                gotoStep: 'alexeyVisit1Write',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit1Write: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: 'Записано!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Закрыть",
                type: "closeTelegramBot",
                gotoStep: 'alexeyVisit2Cabinet',
                value: false,
                redColor: false,
                answered: false,
                patient: "Alexey"
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2Cabinet: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: true,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: 'patientAlexeyCardSecond',
        closeClick: '',
        transform: 'translateX(0) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    patientAlexeyCardSecond: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "AlexeyAnalyzes2",
            closeClick: "alexeyVisit2Attantion",
            pages: [`${base}/images/patient_alexey_card1.png`, `${base}/images/patient_alexey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    AlexeyAnalyzes2: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "patientAlexeyCardSecond",
            nextClick: "alexeyVisit2Attantion",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_alexey_2_1_table.jpg`],
                [`${base}/images/analiz_alexey_2_2_table.jpg`],
                [`${base}/images/analiz_alexey_2_3_table.jpg`],
                [`${base}/images/analiz_alexey_2_4_table.jpg`],
                [`${base}/images/analiz_alexey_2_5_table.jpg`]
            ],
            analyzesHeights: [
                [394],
                [680],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2Attantion: {
        patient: 'Alexey',
        branch: 1,
        name: '❗ ВНИМАНИЕ',
        text: '<strong>📘 Для более точной постановки диагноза изучите карточки по проточной цитометрии и получите за это гематогенку!</strong> Увеличьте свой шанс на верный ответ! 🏅🎉<br>👀 Нажмите <strong>"Изучить"</strong> – там свежий материал!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {
                text: "Изучить материалы",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Read1',
                value: false,
                redColor: true,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2Read1: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        buttons: [],
        background: `${base}/images/cabinet.jpg`,
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {
            closeClick: "alexeyGematogen3",
            pages: [
                {image: `${base}/images/alexey_teach3_1.png`, scroll: true},
                {image: `${base}/images/alexey_teach3_2.png`, scroll: true},
                {image: `${base}/images/alexey_teach3_3.png`, scroll: true},
                {image: `${base}/images/alexey_teach3_4.png`, scroll: true},
            ]
        }
    },
    alexeyGematogen3: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '<strong>А вот и награда!</strong> Держите гематогенку в шуршащем фантике!<br><br><strong>Количество 🍫: (отображение)</strong>',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: true,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: 'firstPrize',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/gematogenka.mp3`,
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {
                text: "Назад",
                type: "nextStep",
                gotoStep: 'alexeyVisit2What',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2What: {
        patient: 'Alexey',
        branch: 1,
        name: 'Надя',
        text: 'Доктор, а что значат результаты проточной цитометрии?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/doctorCenter.jpg`,
        buttons: [
            {
                text: "Открыть результаты",
                type: "nextStep",
                gotoStep: 'AlexeyAnalyzes3',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    AlexeyAnalyzes3: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "patientAlexeyCardThird",
            nextClick: "alexeyVisit2What2",
            windowType: 1,
            windowStartPage: 3,
            analyzes: [
                [`${base}/images/analiz_alexey_2_1_table.jpg`],
                [`${base}/images/analiz_alexey_2_2_table.jpg`],
                [`${base}/images/analiz_alexey_2_3_table.jpg`],
                [`${base}/images/analiz_alexey_2_4_table.jpg`],
                [`${base}/images/analiz_alexey_2_5_table.jpg`]
            ],
            analyzesHeights: [
                [394],
                [680],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    patientAlexeyCardThird: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "AlexeyAnalyzes3",
            closeClick: "alexeyVisit2What2",
            pages: [`${base}/images/patient_alexey_card1.png`, `${base}/images/patient_alexey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2What2: {
        patient: 'Alexey',
        branch: 1,
        name: 'Вы',
        text: 'ПНГ-клон обнаружен сразу в трёх популяциях клеток.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/doctorCenter.jpg`,
        buttons: [
            {
                text: "Далее",
                type: "nextStep",
                gotoStep: 'alexeyVisit2FiveBtn',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2FiveBtn: {
        patient: 'Alexey',
        branch: 1,
        name: 'Надя',
        text: 'А скажите, на какие параметры обратить внимание?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/doctorCenter.jpg`,
        buttons: [
            {
                text: "Эритроц.",
                type: "nextStep",
                gotoStep: 'alexeyVisit2FiveBtn1',
                value: false,
                redColor: false,
                answered: false,
                width: 'calc(33% - 12px)'
            },
            {
                text: "Гранулоц.",
                type: "nextStep",
                gotoStep: 'alexeyVisit2FiveBtn1',
                value: false,
                redColor: false,
                answered: false,
                width: 'calc(33% - 12px)'
            },
            {
                text: "Моноц.",
                type: "nextStep",
                gotoStep: 'alexeyVisit2FiveBtn1',
                value: false,
                redColor: false,
                answered: false,
                width: 'calc(33% - 12px)'
            },
            {
                text: "Гранул. + моноц.",
                type: "nextStep",
                gotoStep: 'alexeyVisit2FiveBtn1',
                value: false,
                redColor: false,
                answered: false,
                width: 'calc(46% - 8px)'
            },
            {
                text: "Эрит.+ гранул.+мон.",
                type: "nextStep",
                gotoStep: 'alexeyVisit2FiveBtn2',
                value: false,
                redColor: false,
                answered: false,
                width: 'calc(54% - 8px)'
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2FiveBtn1: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: 'Кажется, нет... Согласно клиническим рекомендациям, ПНГ-клон оценивается по нескольким клеточным линиям -эритроциты, нейтрофилы и моноциты.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {
                text: "Ссылка",
                type: "nextStep",
                gotoStep: 'alexeyVisit2FiveBtn1Link',
                value: false,
                redColor: false,
                answered: false
            },
            {
                text: "Назад",
                type: "nextStep",
                gotoStep: 'alexeyVisit2FiveBtn',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2FiveBtn2: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '<strong>Совершенно верно! + 30 баллов!<br><br>🏆 Ваш рейтинг: ???⭐<br><br>Как повысить рейтинг?</strong><br>✅ За каждый верный ответ вы получаете баллы рейтинга! 🩺🧠<br>✅ Изучение новой информации в приложении увеличивает шансы на верные решения!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/points.mp3`,
        rating: 30,
        background: `${base}/images/cabinet.jpg`,
        buttons: [
            {
                text: "Ссылка",
                type: "nextStep",
                gotoStep: 'alexeyVisit2FiveBtn2Link',
                value: false,
                redColor: false,
                answered: false
            },
            {
                text: "Далее",
                type: "nextStep",
                gotoStep: 'tuktuk2Alexey',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2FiveBtn1Link: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '<strong>Клинические рекомендации<br> “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс. <br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Назад",
                type: "nextStep",
                gotoStep: 'alexeyVisit2FiveBtn1',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2FiveBtn2Link: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '<strong>Клинические рекомендации<br> “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс. <br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Назад",
                type: "nextStep",
                gotoStep: 'alexeyVisit2FiveBtn2',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    tuktuk2Alexey: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: 'Тихий стук в дверь',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/tuktuk.mp3`,
        rating: 0,
        background: `${base}/images/tuktuk.jpg`,
        buttons: [
            {
                text: "Входите 💡",
                type: "nextStep",
                gotoStep: 'enter2Alexey',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    enter2Alexey: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyEnter.jpg`,
        buttons: [
            {
                text: "Здравствуйте, проходите, ну как вы?",
                type: "nextStep",
                gotoStep: 'alexeyVisit2FirstQuestion',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2FirstQuestion: {
        patient: 'Alexey',
        branch: 1,
        name: 'Алексей',
        text: 'Добрый день... Доктор, знаете.. Мне стало хуже. Я вообще жаловаться не люблю, но я если работать не смогу - как мне семью содержать? Я до больницы еле дошел.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Опросить",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Questions',
                value: false,
                redColor: false,
                answered: false,
                canDisabled: true
            },
            {
                text: "Посмотреть анализы",
                type: "nextStep",
                gotoStep: 'AlexeyAnalyzes4',
                value: false,
                redColor: false,
                answered: false,
                canDisabled: true
            },
            {
                text: "Далее",
                type: "nextStep",
                gotoStep: 'alexeyVisit2AfterQuestion',
                value: false,
                redColor: false,
                answered: true,
                canDisabled: false,
                startInvisible: true
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2Questions: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Усталость и анемия",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Question1',
                value: false,
                redColor: false,
                answered: false,
                canDisabled: true,
                page: 1
            },
            {
                text: "Тромбозы",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Question2',
                value: false,
                redColor: false,
                answered: false,
                width: 'calc(50% - 8px)',
                canDisabled: true,
                page: 1
            },
            {
                text: "Отечность ног",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Question3',
                value: false,
                redColor: false,
                answered: false,
                width: 'calc(50% - 8px)',
                canDisabled: true,
                page: 1
            },
            {
                text: "Физическая нагрузка",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Question4',
                value: false,
                redColor: false,
                answered: false,
                canDisabled: true,
                page: 1
            },
            {
                text: "Боль в животе",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Question5',
                value: false,
                redColor: false,
                answered: false,
                canDisabled: true,
                page: 2
            },
            {
                text: "Темный цвет мочи по утрам",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Question6',
                value: false,
                redColor: false,
                answered: false,
                canDisabled: true,
                page: 2
            },
            {
                text: "arrow_prev",
                type: "nextStep",
                gotoStep: '',
                value: false,
                redColor: false,
                answered: true,
                width: 'calc(50% - 8px)',
                canDisabled: false
            },
            {
                text: "arrow_next",
                type: "nextStep",
                gotoStep: '',
                value: false,
                redColor: false,
                answered: true,
                width: 'calc(50% - 8px)',
                canDisabled: false
            },
            {
                text: "Далее",
                type: "nextStep",
                gotoStep: 'alexeyVisit2FirstQuestion',
                value: false,
                redColor: false,
                answered: true,
                canDisabled: true
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2Question1: {
        patient: 'Alexey',
        branch: 1,
        name: 'Алексей',
        text: 'Устаю я чертовски сильно. Не хочется мне таким быть. Я привык к энергичности в своей жизни.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Опросить",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Questions',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2Question2: {
        patient: 'Alexey',
        branch: 1,
        name: 'Алексей',
        text: 'Нет, доктор, таких проблем не наблюдается.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Опросить",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Questions',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2Question3: {
        patient: 'Alexey',
        branch: 1,
        name: 'Алексей',
        text: 'Нет, доктор, таких проблем не наблюдается.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Опросить",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Questions',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2Question4: {
        patient: 'Alexey',
        branch: 1,
        name: 'Алексей',
        text: 'Одышка усилилась. Я когда с работы иду домой - там по такому холмику небольшому забраться надо. Так вот раньше я даже не замечал, что там холм, а сейчас домой захожу после этого подъема и сижу еще в коридоре, отдышаться пытаюсь несколько минут.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Опросить",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Questions',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2Question5: {
        patient: 'Alexey',
        branch: 1,
        name: 'Алексей',
        text: 'Было еще несколько раз, что как будто что-то болело в животе, но невозможно точно сказать, где именно это было.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Опросить",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Questions',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2Question6: {
        patient: 'Alexey',
        branch: 1,
        name: 'Алексей',
        text: 'Новых эпизодов не было, только вот в прошлый раз то что я вам рассказывал.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Опросить",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Questions',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    AlexeyAnalyzes4: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/cabinet.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {
            toCardClick: "patientAlexeyCardThird2",
            nextClick: "alexeyVisit2FirstQuestion",
            windowType: 1,
            analyzes: [
                [`${base}/images/analiz_alexey_2_1_table.jpg`],
                [`${base}/images/analiz_alexey_2_2_table.jpg`],
                [`${base}/images/analiz_alexey_2_3_table.jpg`],
                [`${base}/images/analiz_alexey_2_4_table.jpg`],
                [`${base}/images/analiz_alexey_2_5_table.jpg`]
            ],
            analyzesHeights: [
                [394],
                [680],
                [342],
                [472],
                [329]
            ]
        },
        teachBlock: {closeClick: "", pages: []}
    },
    patientAlexeyCardThird2: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: false,
        textHeight: 'auto',
        positionTop: true,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: `${base}/audio/card.mp3`,
        rating: 0,
        background: `${base}/images/cabinet_card.jpg`,
        buttons: [],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {
            analyzesStep: "AlexeyAnalyzes4",
            closeClick: "alexeyVisit2FirstQuestion",
            pages: [`${base}/images/patient_alexey_card1.png`, `${base}/images/patient_alexey_card2.png`]
        },
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2AfterQuestion: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Физикальный осмотр",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Osmotr',
                value: false,
                redColor: false,
                answered: false,
                canDisabled: true
            },
            {
                text: "Далее",
                type: "nextStep",
                gotoStep: 'alexeyVisit2NextDiagnose',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2Osmotr: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Пульс",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Osmotr1',
                value: false,
                redColor: false,
                answered: false,
                canDisabled: true
            },
            {
                text: "Кожа",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Osmotr2',
                value: false,
                redColor: false,
                answered: false,
                canDisabled: true
            },
            {
                text: "Пальпация живота",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Osmotr3',
                value: false,
                redColor: false,
                answered: false,
                canDisabled: true
            },
            {
                text: "Далее",
                type: "nextStep",
                gotoStep: 'alexeyVisit2AfterQuestion',
                value: false,
                redColor: false,
                answered: true,
                canDisabled: true
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2Osmotr1: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: 'Тахикардия. ЧСС - 104 уд/м',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Назад",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Osmotr',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2Osmotr2: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: 'Наблюдается заметная бледность кожных покровов, а так же желтушность склер.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Назад",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Osmotr',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2Osmotr3: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: 'Отклонений при пальпации не обнаружено',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/keyboard.mp3`,
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Назад",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Osmotr',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2NextDiagnose: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Предположить диагноз",
                type: "nextStep",
                gotoStep: 'alexeyVisit2DiagnoseBtns',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2DiagnoseBtns: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "ПНГ",
                type: "nextStep",
                gotoStep: 'alexeyVisit2DiagnoseBtn1',
                value: false,
                redColor: false,
                answered: false
            },
            {
                text: "АИГА",
                type: "nextStep",
                gotoStep: 'alexeyVisit2DiagnoseBtn2',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2DiagnoseBtn1: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '<strong>Верно!</strong> У пациента наблюдается характерная клиническая и лабораторная картина внутрисосудистого гемолиза - повышенная активность лактатдегидрогеназы, общего билирубина за счет непрямой фракции, а также жалобы, связанные с усталостью, абдоминальной болью, эпизодами гемоглобинурии. Проточная цитометрия выявила в периферической крови ПНГ-клон. Таким образом, диагноз пациента - ПНГ.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Ссылка",
                type: "nextStep",
                gotoStep: 'alexeyVisit2DiagnoseBtn1Link',
                value: false,
                redColor: false,
                answered: false
            },
            {
                text: "Далее",
                type: "nextStep",
                gotoStep: 'alexeyVisit2DiagnoseWin',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2DiagnoseBtn2: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '<strong>Неверно!</strong> У пациента наблюдается характерная клиническая и лабораторная картина внутрисосудистого гемолиза - повышенная активность лактатдегидрогеназы, общего билирубина за счет непрямой фракции, а также жалобы, связанные с усталостью, абдоминальной болью, эпизодами гемоглобинурии. Проточная цитометрия выявила в периферической крови ПНГ-клон.<br><br>Отрицательная проба Кумбса также может указывать на то, что диагноз пациента связан с комплемент-опосредованным гемолизом.<br><br>Таким образом, можно утверждать, что диагноз пациента - пароксизмальная ночная гемоглобинурия.',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '140px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Ссылка",
                type: "nextStep",
                gotoStep: 'alexeyVisit2DiagnoseBtn2Link',
                value: false,
                redColor: false,
                answered: false
            },
            {
                text: "Далее",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Finish',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2DiagnoseBtn1Link: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Назад",
                type: "nextStep",
                gotoStep: 'alexeyVisit2DiagnoseBtn1',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2DiagnoseBtn2Link: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)<br><br><strong>Клинические рекомендации по диагностике и лечению аутоиммунной гемолитической анемии (АИГА) у взрослых // Национальное гематологическое общество.</strong><br><a href="https://npngo.ru/uploads/media_document/291/84cbcaeb-518f-4a7d-b081-88f7fbb016fc.pdf">https://npngo.ru/uploads/media_document/291/84cbcaeb-518f-4a7d-b081-88f7fbb016fc.pdf</a><br>(дата обращения: 01.05.2025)',
        bitTitle: false,
        textIsMaxSize: true,
        isEnter: true,
        textHeight: '140px',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Назад",
                type: "nextStep",
                gotoStep: 'alexeyVisit2DiagnoseBtn2',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2DiagnoseWin: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '<strong>Совершенно верно! + 30 баллов!<br><br>🏆 Ваш рейтинг: ???⭐<br><br>Как повысить рейтинг?</strong><br>✅ За каждый верный ответ вы получаете баллы рейтинга! 🩺🧠<br>✅ Изучение новой информации в приложении увеличивает шансы на верные решения!',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: `${base}/audio/points.mp3`,
        rating: 30,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Далее",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Finish',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2Finish: {
        patient: 'Alexey',
        branch: 1,
        name: 'Вы',
        text: 'Алексей Игнатьевич, у меня для вас следующие новости: полученные в ходе исследований данные могут указывать на наличие у Вас такого редкого заболевания, как пароксизмальная ночная гемоглобинурия.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Далее",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Finish2',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2Finish2: {
        patient: 'Alexey',
        branch: 1,
        name: 'Алексей',
        text: 'Что это за болезнь? Никогда не слышал о такой...',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Далее",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Finish3',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2Finish3: {
        patient: 'Alexey',
        branch: 1,
        name: 'Вы',
        text: 'Несмотря на то, что это заболевание редкое, уже сейчас доступны опции патогенетического лечения, которые могут помочь Вам вернуться к полноценной жизни. Сейчас я вам немного объясню суть вашего диагноза.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Далее",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Finish4',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2Finish4: {
        patient: 'Alexey',
        branch: 1,
        name: 'Вы',
        text: 'ПНГ — это редкое приобретенное клональное заболевание системы крови, характеризующееся внутрисосудистым гемолизом, дисфункцией костного мозга и повышенным риском тромботических и органных осложнений.',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Ссылка",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Finish4Link',
                value: false,
                redColor: false,
                answered: false
            },
            {
                text: "Далее",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Finish5',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2Finish4Link: {
        patient: 'Alexey',
        branch: 1,
        name: '',
        text: '<strong>Клинические рекомендации “Пароксизмальная ночная гемоглобинурия” 2024.</strong><br>Электронный ресурс.<br><a href="https://cr.minzdrav.gov.ru/preview-cr/695_2">https://cr.minzdrav.gov.ru/preview-cr/695_2</a><br>(дата обращения: 08.07.2025)',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-40%) translateY(-50%)',
        transition: 'all 800ms cubic-bezier(.77,.1,.45,.95)',
        left: '50%',
        top: '50%',
        height: '130%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Назад",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Finish4',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2Finish5: {
        patient: 'Alexey',
        branch: 1,
        name: 'Алексей',
        text: 'И что же мне делать с этим? Когда я смогу вернуться на работу? Я смогу работать?',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Далее",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Finish6',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2Finish6: {
        patient: 'Alexey',
        branch: 1,
        name: 'Вы',
        text: 'Сначала подготовимся к терапии: проведем вакцинацию. Затем вы начнете лечение. Не переживайте. Вы сможете и работать, и жить полноценной жизнью. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Далее",
                type: "nextStep",
                gotoStep: 'alexeyVisit2Finish7',
                value: false,
                redColor: false,
                answered: false
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
    alexeyVisit2Finish7: {
        patient: 'Alexey',
        branch: 1,
        name: 'Алексей',
        text: 'Понял! Сначала вакцины, потом лечение. Спасибо, доктор, вы меня немного успокоили. Буду лечиться. ',
        bitTitle: false,
        textIsMaxSize: false,
        isEnter: true,
        textHeight: 'auto',
        positionTop: false,
        hasPatient: false,
        speak: false,
        draggable: false,
        aspectRatio: true,
        gematogen: false,
        isPrize: false,
        isPrizeShow: false,
        prize: 0,
        prizes: [],
        pcClick: '',
        cardClick: '',
        closeClick: '',
        transform: 'translateX(-50%) translateY(-50%)',
        transition: 'none',
        left: '50%',
        top: '50%',
        height: '100%',
        singlePCWindow: '',
        stepSound: '',
        rating: 0,
        background: `${base}/images/AlexeyCabinet.jpg`,
        buttons: [
            {
                text: "Закончить прием",
                type: "closeTelegramBot",
                gotoStep: 'start',
                value: false,
                redColor: false,
                answered: false,
                patient: 'Aksinya'
            },
        ],
        question: {title: "", result: "", nextStep: "", nextStepCorrect: "", answers: []},
        patientCard: {analyzesStep: "", closeClick: "", pages: []},
        patientAnalyzes: {toCardClick: "", nextClick: "", windowType: 0, analyzes: [], analyzesHeights: []},
        teachBlock: {closeClick: "", pages: []}
    },
}
